import { IconButton } from "@mui/material";
import { Stack } from "~/components/ui/stack";
import { XOutlineIcon } from "~/components/ui/icon";
import { Heading } from "~/components/ui/heading";

type DialogHeaderProps = {
  onClose: () => void;
  children: React.ReactNode;
};

export const DialogHeader = ({ children, onClose }: DialogHeaderProps) => {
  const header =
    typeof children === "string" ? (
      <Heading level="3">{children}</Heading>
    ) : (
      children
    );

  return (
    <Stack
      direction="row"
      justify="space-between"
      align="center"
      paddingX="large"
      paddingY="small"
    >
      {header}

      <IconButton aria-label="Close" onClick={onClose}>
        <XOutlineIcon />
      </IconButton>
    </Stack>
  );
};
